<template>
  <div>
    <form ref="agentForm">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Agent Name
          </label>
          <input
            v-model="form.name"
            type="text"
            placeholder="Enter name (eg. Dela Cruz, Juan)"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Birth Date
          </label>
          <input
            v-model="form.birthdate"
            type="date"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm"
          />
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Home Address
          </label>
          <input
            v-model="form.address"
            type="text"
            placeholder="Enter address"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm"
          />
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Email Address
          </label>
          <input
            v-model="form.email"
            type="email"
            placeholder="Enter email"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm"
          />
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Sales Manager / Managing Broker
          </label>
          <input
            v-model="form.broker"
            type="text"
            placeholder="Broker name"
            required
            disabled
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm bg-gray-100"
          />
          <p class="text-sm text-gray-500 mt-2">
            Broker Code: {{ formData.brokercode }}
          </p>
        </div>
        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Designation
          </label>
          <input
            v-model="form.designation"
            type="text"
            placeholder="Enter designation"
            required
            disabled
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm bg-gray-100"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            Mobile Number
          </label>
          <input
            v-model="form.cellphoneno"
            type="tel"
            placeholder="e.g. +63 912 345 6789"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            TIN
          </label>
          <input
            v-model="form.tin"
            type="text"
            placeholder="Enter TIN number"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm"
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            SSS Number
          </label>
          <input
            v-model="form.sss"
            type="text"
            placeholder="Enter SSS number"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm"
          />
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-txt-primary-color mb-2">
            One-Time Authorization Code
          </label>

          <input
            v-model="form.otac"
            @blur="validateOtac"
            type="text"
            placeholder="Enter OTAC code"
            required
            class="w-full px-4 py-3 border border-brd-primary-color rounded-xl shadow-sm"
          />
          <p
            v-if="validationMessage"
            class="mt-2 text-sm font-medium"
            :class="isStatusValid ? 'text-green-600' : 'text-red-600'"
          >
            {{ validationMessage }}
          </p>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { toRefs, ref, inject, onMounted } from "vue";
import { useRoute } from "vue-router";

export default {
  props: {
    formData: { type: Object, required: true },
  },
  emits: ["otacValidated"],
  setup(props, { emit }) {
    const axios = inject("$axios");
    const route = useRoute();
    const { formData: form } = toRefs(props);
    const agentForm = ref(null);
    const validationMessage = ref("");
    const isStatusValid = ref(null);
    const debugLog = ref("");

    const fetchBroker = async (code) => {
      try {
        debugLog.value = `Fetching broker ${code}`;
        const response = await axios.get(`/wb/agent/broker/${code}`);
        const data = response.data;
        debugLog.value = `Broker response: ${JSON.stringify(data)}`;
        if (data.status && data.data) {
          form.value.broker = data.data.name;
          emit("brokerCodeDetected", code);
        }
      } catch (error) {
        debugLog.value = "Error fetching broker.";
      }
    };

    const validateOtac = async () => {
      const code = form.value.otac?.trim();
      if (!code) {
        validationMessage.value = "";
        isStatusValid.value = null;
        emit("otacValidated", null);
        return;
      }
      try {
        const response = await axios.get(`/wb/verification/otac/${code}`);
        const data = response.data;
        validationMessage.value = data.message;
        isStatusValid.value = data.status;
        emit("otacValidated", data.status ? true : null);
      } catch (error) {
        validationMessage.value = "Error verifying OTAC.";
        isStatusValid.value = false;
        emit("otacValidated", null);
      }
    };

    onMounted(() => {
      const brokerCode = route.params.code || "865416";
      if (brokerCode) {
        fetchBroker(brokerCode);
      }
    });

    return {
      form,
      agentForm,
      validationMessage,
      isStatusValid,
      validateOtac,
      debugLog,
    };
  },
};
</script>
